var FishingRedirector = xClass("FishingRedirector", BaseRedirector)
FishingRedirector.prototype.getName = function () {
    var self = this
    return "fishing"
}
FishingRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param
    var um = UserManager.getInstance();
    console.log("StarDream StarDreamRedirector um.settings", um.settings)
    if (!Object.keys(um.settings.data).length) {
        // um还没解析login, 等待下次执行
        return false;
    }
    let FishingMgr = null;
    try {
        FishingMgr = FishingManager.getInstance();
    } catch (e) {
        //直接点击链接进入的
    }
    // require("activity/Fishing/FishingManager");
    // let FishingMgr = FishingManager.getInstance();

    let dcFishing = function (result, fishId) {
        let levelid = "";
        let t2 = "";
        let t3 = fishId ? fishId : "";
        if (FishingMgr && FishingMgr.isOpen()) {
            levelid = FishingMgr.getDcLevelId();
            t2 = FishingMgr.info.roundId;
        }
        DCAssist.userTrack(ModuleName.FISHING, "enter_via_share",
            {
                session: `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`,
                result,
                levelid,
                t2,
                t3,
            });
    }

    //  检查是否为点自己的链接
    let uid = um.uid;
    let inviteCode = param["inviteCode"] == null ? null : +param["inviteCode"];
    let isMythis = inviteCode === uid || false;
    if (isMythis) {
        Toast.make(getText("点击自己的链接无效哦，去分享给好友吧~"));
        dcFishing("self");
        return true;
    }

    if (param.shareId && param.fishId) {
        let onInfoSuccess = function (evt) {
            if (evt && evt.data) {
                const data = evt.data;
                Toast.make("成功解锁新的图鉴啦~");
                const fishId = Number(param.fishId);
                if (FishingMgr && FishingMgr.isOpen()) {
                    if (!FishingMgr.getFishBook(fishId)) {
                        FishingMgr.addNewFish(fishId);
                        FishingMgr.haveNewFishBook = true;
                        FishingMgr.getInfo().then((data) => {
                            const Event = require("hecore/EventDispatcher").Event;
                            GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kFishingGetBook,
                                {
                                    fishId,
                                }))
                        })
                    }
                }
                dcFishing("success", fishId);
            }
        }
        let onInfoFail = function (evt) {
            let result = null;
            switch (evt.data) {
                case 762523:
                    result = "end";
                    break;
                case 762526:
                    result = "empty";
                    break;
                case 762522:
                    result = "had";
                    break;
                case 762518:
                    result = "self";
                    break;
                case 762512:
                    result = "to_join";
                    break;
                case 762521:
                    result = "limit";
                    break;
            }
            if (result) {
                dcFishing(result);
            }
            //
            let tips = {
                "762518": "不可以点击自己的分享哦~",
                "762519": "这个链接不存在哦~",
                "762520": "分享链接已经过期咯~,",
                "762521": "今天领取的次数已经到上限了，明天再试试吧~",
                "762522": "这条鱼已经拥有了哦~",
                "762523": "比赛已经结束啦~",
                "762524": "当前平台不支持活动分享哦~",
                "762525": "当前剩余数量不足，无法分享哦~",
                "762526": "这个链接已经被领取过啦！",
            }
            let str = "网络异常状态，请检查网络连接！";
            if (tips[evt.data]) {
                str = tips[evt.data];
            }
            Toast.make(str);
        }

        let http = FishingShareClickHttp.new();
        http.addEventListener(Events.kComplete, onInfoSuccess);
        http.addEventListener(Events.kError, onInfoFail);
        http.addEventListener(Events.kCancel, onInfoFail);
        http.load(inviteCode, param.shareId, param.fishId);

        // FishingManager.getInstance().shareClick(inviteCode, param.shareId, param.shareId).then(() => {

        // })
    }
    return true;
}

module.exports = FishingRedirector
